/**
 * ChatAIButton Component
 *
 * @module core/chat/components
 * @version 1.0
 *
 * @description
 * Botón circular con glassmorphism para abrir el chat IA.
 * Se ubica en el TopBar junto a UIScaleButton y LanguageSelector.
 */

import './chat-ai-button.css';
import { WaylineChatIcon } from './WaylineChatIcon';

export interface ChatAIButtonProps {
  /**
   * Callback cuando se hace click en el botón
   */
  onClick?: () => void;

  /**
   * Si el chat está actualmente abierto
   */
  isActive?: boolean;

  /**
   * Si el asistente está "pensando" (cargando respuesta)
   */
  isLoading?: boolean;
}

/**
 * Botón para activar el chat IA
 *
 * @remarks
 * - Icono W segmentada con spark para representar IA
 * - Glow cyan cuando está activo o cargando
 * - Matching visual con UIScaleButton y LanguageSelector
 * - Tooltip con descripción
 */
export function ChatAIButton({
  onClick,
  isActive = false,
  isLoading = false,
}: ChatAIButtonProps): JSX.Element {
  return (
    <button
      className={`chat-ai-btn ${isActive ? 'active' : ''} ${isLoading ? 'loading' : ''}`}
      onClick={onClick}
      aria-label="Chat con IA"
      title="Asistente IA - Analiza tu proyecto"
      type="button"
    >
      <WaylineChatIcon size={20} className="chat-ai-btn__icon" />

      {/* Pulse animation cuando está cargando */}
      {isLoading && <span className="loading-pulse" />}
    </button>
  );
}
